import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { createEmptyObjectCollection, CUSTOMER_STATUS, IComment, ICustomer, IObjectAddress, IReference } from '@nova/common-interfaces';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TextareaModule } from 'primeng/textarea';
import { CustomerService } from '../../../../shared/services/customers/customers.service.mjs';

@Component({
  selector: 'app-customer-create',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    TextareaModule,
    ButtonModule,
    ProgressSpinnerModule,
    InputNumberModule,
  ],
  templateUrl: './customer-create.component.html',
  styleUrls: ['./customer-create.component.scss'],
  encapsulation: ViewEncapsulation.None,
 
})
export class CustomerCreateComponent implements OnInit {
  customerForm!: FormGroup;
  isLoading = true;
  customerId!: string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.customerForm = this.fb.group({
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      email: ["", Validators.required],
      line1: ["", Validators.required],
    });
    this.isLoading = false;
}

  onSubmit(): void {
    if (this.customerForm.valid) {
      this.isLoading = true;

      const newCustomer: ICustomer = { ...this.customerForm.value };
      newCustomer.status = CUSTOMER_STATUS.LEAD;
      newCustomer.mailing_address = {
        line1: this.customerForm.get("line1")?.value
      } as IObjectAddress;
      newCustomer.latitude = 0;
      newCustomer.longitude = 0;
      newCustomer.activation_date = 0;
      newCustomer.mobile_phone = "";
      newCustomer.home_home = "";
      newCustomer.name = `${newCustomer.first_name} ${newCustomer.last_name}`;
      newCustomer.autopay_status = false;
      newCustomer.token_uid = "";
      newCustomer.comments = createEmptyObjectCollection<IComment>();
      newCustomer.reference_keys = createEmptyObjectCollection<IReference>();
      this.customerService.insert(newCustomer)
        .then(() => {
          console.log('Customer create successfully');
          this.router.navigate(['/admin/customers']);
        })
        .catch((error) => {
          console.error('Error creating customer:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
